/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as WorkflowsImport } from './routes/workflows'
import { Route as TracesImport } from './routes/traces'
import { Route as IndexImport } from './routes/index'
import { Route as WorkflowsIndexImport } from './routes/workflows.index'
import { Route as TracesIndexImport } from './routes/traces.index'
import { Route as WorkflowsNewImport } from './routes/workflows.new'
import { Route as WorkflowsWorkflowIdImport } from './routes/workflows.$workflowId'
import { Route as UNRELEASEDtracesTraceIdImport } from './routes/UNRELEASEDtraces.$traceId'

// Create/Update Routes

const WorkflowsRoute = WorkflowsImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => rootRoute,
} as any)

const TracesRoute = TracesImport.update({
  id: '/traces',
  path: '/traces',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const WorkflowsIndexRoute = WorkflowsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkflowsRoute,
} as any)

const TracesIndexRoute = TracesIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TracesRoute,
} as any)

const WorkflowsNewRoute = WorkflowsNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => WorkflowsRoute,
} as any)

const WorkflowsWorkflowIdRoute = WorkflowsWorkflowIdImport.update({
  id: '/$workflowId',
  path: '/$workflowId',
  getParentRoute: () => WorkflowsRoute,
} as any)

const UNRELEASEDtracesTraceIdRoute = UNRELEASEDtracesTraceIdImport.update({
  id: '/UNRELEASEDtraces/$traceId',
  path: '/UNRELEASEDtraces/$traceId',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/traces': {
      id: '/traces'
      path: '/traces'
      fullPath: '/traces'
      preLoaderRoute: typeof TracesImport
      parentRoute: typeof rootRoute
    }
    '/workflows': {
      id: '/workflows'
      path: '/workflows'
      fullPath: '/workflows'
      preLoaderRoute: typeof WorkflowsImport
      parentRoute: typeof rootRoute
    }
    '/UNRELEASEDtraces/$traceId': {
      id: '/UNRELEASEDtraces/$traceId'
      path: '/UNRELEASEDtraces/$traceId'
      fullPath: '/UNRELEASEDtraces/$traceId'
      preLoaderRoute: typeof UNRELEASEDtracesTraceIdImport
      parentRoute: typeof rootRoute
    }
    '/workflows/$workflowId': {
      id: '/workflows/$workflowId'
      path: '/$workflowId'
      fullPath: '/workflows/$workflowId'
      preLoaderRoute: typeof WorkflowsWorkflowIdImport
      parentRoute: typeof WorkflowsImport
    }
    '/workflows/new': {
      id: '/workflows/new'
      path: '/new'
      fullPath: '/workflows/new'
      preLoaderRoute: typeof WorkflowsNewImport
      parentRoute: typeof WorkflowsImport
    }
    '/traces/': {
      id: '/traces/'
      path: '/'
      fullPath: '/traces/'
      preLoaderRoute: typeof TracesIndexImport
      parentRoute: typeof TracesImport
    }
    '/workflows/': {
      id: '/workflows/'
      path: '/'
      fullPath: '/workflows/'
      preLoaderRoute: typeof WorkflowsIndexImport
      parentRoute: typeof WorkflowsImport
    }
  }
}

// Create and export the route tree

interface TracesRouteChildren {
  TracesIndexRoute: typeof TracesIndexRoute
}

const TracesRouteChildren: TracesRouteChildren = {
  TracesIndexRoute: TracesIndexRoute,
}

const TracesRouteWithChildren =
  TracesRoute._addFileChildren(TracesRouteChildren)

interface WorkflowsRouteChildren {
  WorkflowsWorkflowIdRoute: typeof WorkflowsWorkflowIdRoute
  WorkflowsNewRoute: typeof WorkflowsNewRoute
  WorkflowsIndexRoute: typeof WorkflowsIndexRoute
}

const WorkflowsRouteChildren: WorkflowsRouteChildren = {
  WorkflowsWorkflowIdRoute: WorkflowsWorkflowIdRoute,
  WorkflowsNewRoute: WorkflowsNewRoute,
  WorkflowsIndexRoute: WorkflowsIndexRoute,
}

const WorkflowsRouteWithChildren = WorkflowsRoute._addFileChildren(
  WorkflowsRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/traces': typeof TracesRouteWithChildren
  '/workflows': typeof WorkflowsRouteWithChildren
  '/UNRELEASEDtraces/$traceId': typeof UNRELEASEDtracesTraceIdRoute
  '/workflows/$workflowId': typeof WorkflowsWorkflowIdRoute
  '/workflows/new': typeof WorkflowsNewRoute
  '/traces/': typeof TracesIndexRoute
  '/workflows/': typeof WorkflowsIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/UNRELEASEDtraces/$traceId': typeof UNRELEASEDtracesTraceIdRoute
  '/workflows/$workflowId': typeof WorkflowsWorkflowIdRoute
  '/workflows/new': typeof WorkflowsNewRoute
  '/traces': typeof TracesIndexRoute
  '/workflows': typeof WorkflowsIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/traces': typeof TracesRouteWithChildren
  '/workflows': typeof WorkflowsRouteWithChildren
  '/UNRELEASEDtraces/$traceId': typeof UNRELEASEDtracesTraceIdRoute
  '/workflows/$workflowId': typeof WorkflowsWorkflowIdRoute
  '/workflows/new': typeof WorkflowsNewRoute
  '/traces/': typeof TracesIndexRoute
  '/workflows/': typeof WorkflowsIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/traces'
    | '/workflows'
    | '/UNRELEASEDtraces/$traceId'
    | '/workflows/$workflowId'
    | '/workflows/new'
    | '/traces/'
    | '/workflows/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/UNRELEASEDtraces/$traceId'
    | '/workflows/$workflowId'
    | '/workflows/new'
    | '/traces'
    | '/workflows'
  id:
    | '__root__'
    | '/'
    | '/traces'
    | '/workflows'
    | '/UNRELEASEDtraces/$traceId'
    | '/workflows/$workflowId'
    | '/workflows/new'
    | '/traces/'
    | '/workflows/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  TracesRoute: typeof TracesRouteWithChildren
  WorkflowsRoute: typeof WorkflowsRouteWithChildren
  UNRELEASEDtracesTraceIdRoute: typeof UNRELEASEDtracesTraceIdRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  TracesRoute: TracesRouteWithChildren,
  WorkflowsRoute: WorkflowsRouteWithChildren,
  UNRELEASEDtracesTraceIdRoute: UNRELEASEDtracesTraceIdRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/traces",
        "/workflows",
        "/UNRELEASEDtraces/$traceId"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/traces": {
      "filePath": "traces.tsx",
      "children": [
        "/traces/"
      ]
    },
    "/workflows": {
      "filePath": "workflows.tsx",
      "children": [
        "/workflows/$workflowId",
        "/workflows/new",
        "/workflows/"
      ]
    },
    "/UNRELEASEDtraces/$traceId": {
      "filePath": "UNRELEASEDtraces.$traceId.tsx"
    },
    "/workflows/$workflowId": {
      "filePath": "workflows.$workflowId.tsx",
      "parent": "/workflows"
    },
    "/workflows/new": {
      "filePath": "workflows.new.tsx",
      "parent": "/workflows"
    },
    "/traces/": {
      "filePath": "traces.index.tsx",
      "parent": "/traces"
    },
    "/workflows/": {
      "filePath": "workflows.index.tsx",
      "parent": "/workflows"
    }
  }
}
ROUTE_MANIFEST_END */
